import { render, staticRenderFns } from "./shoppingCart.vue?vue&type=template&id=2b55d46c"
import script from "./shoppingCart.vue?vue&type=script&lang=js"
export * from "./shoppingCart.vue?vue&type=script&lang=js"
import style0 from "./shoppingCart.vue?vue&type=style&index=0&id=2b55d46c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports